import { Range } from '../types/helperTypes';

export const mod = <T extends number>(value: number, modulo: T): Range<0, T> => (value % modulo) as Range<0, T>;
